import LocationInputComponent from './LocationInputComponent';
export default LocationInputComponent;
